import { render, staticRenderFns } from "./index.vue?vue&type=template&id=80fad5c4&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=80fad5c4&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80fad5c4')) {
      api.createRecord('80fad5c4', component.options)
    } else {
      api.reload('80fad5c4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=80fad5c4&", function () {
      api.rerender('80fad5c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/agent/index.vue"
export default component.exports